// Footer.js
import React from "react";
import { Container, Row, Col } from "reactstrap";
import { FaInstagram, FaFacebookF, FaYoutube, FaEnvelope, FaLinkedinIn, FaWhatsapp, FaPhone } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#000",
        color: "#fff",
        padding: "40px 20px 20px",
        marginTop: "50px",
      }}
    >
      <Container fluid>
        <Row className="gy-4">
          {/* Column 1: Address & Contact */}
          <Col lg={4} md={6} sm={12}>
            <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>Contact Us</h5>
            <p>B/9, Ratnam Park, Nr Amin Party Plot, Gotri, Vadodara, Gujarat, India.</p>
            <p>
              Email:{" "}
              <a href="mailto:aiinrealestate.in@gmail.com" style={{ color: "#fff", textDecoration: "underline" }}>
                vivek.brahmbhatt@aiinrealestate.in, aiinrealestate.in@gmail.com
              </a>
            </p>
            <p>
              Phone:{" "}
              <a href="tel:9586363303" style={{ color: "#fff", textDecoration: "underline" }}>
                9586363303, 9879963303
              </a>
            </p>
            <div className="d-flex gap-3 mt-3">
              <a href="https://www.instagram.com/aiinrealestate.in/" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "1.4rem" }}>
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/aiinrealestate" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "1.4rem" }}>
                <FaFacebookF />
              </a>
              <a href="https://www.youtube.com/@aiinrealestate" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "1.4rem" }}>
                <FaYoutube />
              </a>
              <a href="mailto:aiinrealestate.in@gmail.com" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "1.4rem" }}>
                <FaEnvelope />
              </a>
              <a href="https://www.linkedin.com/in/aiinrealestate/" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "1.4rem" }}>
                <FaLinkedinIn />
              </a>
            </div>
          </Col>

          {/* Column 2: Map */}
          <Col lg={4} md={6} sm={12}>
            <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>Our Location</h5>
            <div style={{ borderRadius: "10px", overflow: "hidden", border: "2px solid #fff" }}>
              <iframe
                title="company-location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.8857092585177!2d73.1381194752993!3d22.300876779693994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8970bbf49f3%3A0x8d8d6e08d89f8e8f!2sGotri%2C%20Vadodara%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1695669876543"
                width="100%"
                height="200"
                style={{ border: "0" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </Col>

          {/* Column 3: Links */}
          <Col lg={4} md={12} sm={12}>
            <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>Quick Links</h5>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, lineHeight: "2" }}>
              <li>
                <Link to="/terms&conditions" style={{ color: "#fff", textDecoration: "underline" }}>
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" style={{ color: "#fff", textDecoration: "underline" }}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/contact" style={{ color: "#fff", textDecoration: "underline" }}>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/home-page" style={{ color: "#fff", textDecoration: "underline" }}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about-us" style={{ color: "#fff", textDecoration: "underline" }}>
                  About Us
                </Link>
              </li>
            </ul>
          </Col>
        </Row>

        <hr style={{ backgroundColor: "#444", margin: "20px 0" }} />

        {/* Bottom Row */}
        <Row>
          <Col md={6} sm={12}>
            <p style={{ margin: 0 }}>
              © {new Date().getFullYear()} AI in Real Estate. All Rights Reserved.
            </p>
          </Col>
          <Col md={6} sm={12} className="text-md-end text-sm-start mt-2 mt-md-0">
            <p style={{ margin: 0 }}>Designed & Developed with ❤️ in India</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;

